import { IHospitalConfiguration } from "../@types/Login";
import { AUTH_HOSPITAL_CONFIGURATION } from "../constants/localStorageKeys";
import { safeJsonParse, safeStorage } from "./storage";

const DEFAULT_WARD_SINGULAR = "Ward";
const DEFAULT_WARD_PLURAL = "Wards";

/**
 * The four casings of the hospital's "Ward" term used across the portal. Only the
 * capitalised forms are configured (per hospital, in Retool); the lower-case forms
 * are derived for mid-sentence usage.
 */
export interface IWardLabel {
  /** Capitalised singular, e.g. "Cohort". Use at the start of labels/titles. */
  singular: string;
  /** Capitalised plural, e.g. "Cohorts". */
  plural: string;
  /** Lower-case singular, e.g. "cohort". Use mid-sentence. */
  singularLower: string;
  /** Lower-case plural, e.g. "cohorts". Use mid-sentence. */
  pluralLower: string;
}

/**
 * Reads the current hospital's ward label from the cached hospital configuration.
 * Plain function (not a hook) so it can be used outside React render — table column
 * factories, Yup schemas, card configs, etc. Falls back to "Ward"/"Wards" when the
 * config is missing or a label is blank (e.g. a config cached before this feature).
 */
export function getWardLabel(): IWardLabel {
  const raw = safeStorage.getItem(AUTH_HOSPITAL_CONFIGURATION);
  const parsed = safeJsonParse<IHospitalConfiguration | undefined>(
    raw,
    undefined
  );

  const singular = parsed?.wardLabelSingular?.trim() || DEFAULT_WARD_SINGULAR;
  const plural = parsed?.wardLabelPlural?.trim() || DEFAULT_WARD_PLURAL;

  return {
    singular,
    plural,
    singularLower: singular.toLowerCase(),
    pluralLower: plural.toLowerCase(),
  };
}
